import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import request from '@/utils/request';
export function getResourcePool() {
  return _getResourcePool.apply(this, arguments);
}
function _getResourcePool() {
  _getResourcePool = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", request({
            url: 'cmdb/v1/pool'
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getResourcePool.apply(this, arguments);
}
export function getBizs(_x) {
  return _getBizs.apply(this, arguments);
}
function _getBizs() {
  _getBizs = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", request({
            url: 'cmdb/v1/biz',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getBizs.apply(this, arguments);
}
export function getMyBizList(_x2) {
  return _getMyBizList.apply(this, arguments);
}
function _getMyBizList() {
  _getMyBizList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", request({
            url: 'cmdb/v2/biz_list',
            params: params
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getMyBizList.apply(this, arguments);
}
export function createBiz(_x3) {
  return _createBiz.apply(this, arguments);
}
function _createBiz() {
  _createBiz = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", request({
            url: 'cmdb/v1/biz',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _createBiz.apply(this, arguments);
}
export function deleteBiz(_x4) {
  return _deleteBiz.apply(this, arguments);
}
function _deleteBiz() {
  _deleteBiz = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", request({
            url: "cmdb/v1/biz/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _deleteBiz.apply(this, arguments);
}
export function getNodes(_x5, _x6) {
  return _getNodes.apply(this, arguments);
}
function _getNodes() {
  _getNodes = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(biz_id, options) {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", request({
            url: 'cmdb/v1/node',
            params: _objectSpread({
              biz_id: biz_id
            }, options)
          }));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getNodes.apply(this, arguments);
}
export function createNode(_x7) {
  return _createNode.apply(this, arguments);
}
function _createNode() {
  _createNode = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(data) {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", request({
            url: 'cmdb/v1/node',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _createNode.apply(this, arguments);
}
export function updateNode(_x8, _x9) {
  return _updateNode.apply(this, arguments);
}
function _updateNode() {
  _updateNode = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(id, data) {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", request({
            url: "cmdb/v1/node/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _updateNode.apply(this, arguments);
}
export function deleteNode(_x10) {
  return _deleteNode.apply(this, arguments);
}
function _deleteNode() {
  _deleteNode = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", request({
            url: "cmdb/v1/node/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _deleteNode.apply(this, arguments);
}
export function getHosts(_x11, _x12) {
  return _getHosts.apply(this, arguments);
}
function _getHosts() {
  _getHosts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(biz_id, options) {
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", request({
            url: 'cmdb/v1/hosts',
            params: _objectSpread({
              biz_id: biz_id
            }, options)
          }));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _getHosts.apply(this, arguments);
}
export function updateHost(_x13, _x14) {
  return _updateHost.apply(this, arguments);
}
function _updateHost() {
  _updateHost = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(id, data) {
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", request({
            url: "cmdb/v1/host/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _updateHost.apply(this, arguments);
}
export function getHostNodes(_x15) {
  return _getHostNodes.apply(this, arguments);
}
function _getHostNodes() {
  _getHostNodes = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", request({
            url: 'cmdb/v1/host_nodes',
            params: {
              id: id
            }
          }));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _getHostNodes.apply(this, arguments);
}
export function updateHostNodes(_x16, _x17, _x18) {
  return _updateHostNodes.apply(this, arguments);
}
function _updateHostNodes() {
  _updateHostNodes = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13(hosts, nodes, replace) {
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.abrupt("return", request({
            url: 'cmdb/v1/host_nodes',
            method: 'put',
            data: {
              hosts: hosts,
              nodes: nodes,
              replace: replace
            }
          }));
        case 1:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _updateHostNodes.apply(this, arguments);
}
export function getDynamicGroups(_x19, _x20) {
  return _getDynamicGroups.apply(this, arguments);
}
function _getDynamicGroups() {
  _getDynamicGroups = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14(biz_id, params) {
    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.abrupt("return", request({
            url: 'cmdb/v1/dynamicgroup',
            params: _objectSpread({
              biz_id: biz_id
            }, params)
          }));
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _getDynamicGroups.apply(this, arguments);
}
export function deleteDynamicGroup(_x21, _x22) {
  return _deleteDynamicGroup.apply(this, arguments);
}
function _deleteDynamicGroup() {
  _deleteDynamicGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee15(biz_id, id) {
    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          return _context15.abrupt("return", request({
            url: "cmdb/v1/dynamicgroup/".concat(id),
            method: 'delete',
            params: {
              biz_id: biz_id
            }
          }));
        case 1:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _deleteDynamicGroup.apply(this, arguments);
}
export function createDynamicGroup(_x23) {
  return _createDynamicGroup.apply(this, arguments);
}
function _createDynamicGroup() {
  _createDynamicGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee16(data) {
    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          return _context16.abrupt("return", request({
            url: 'cmdb/v1/dynamicgroup',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _createDynamicGroup.apply(this, arguments);
}
export function updateDynamicGroup(_x24, _x25) {
  return _updateDynamicGroup.apply(this, arguments);
}
function _updateDynamicGroup() {
  _updateDynamicGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee17(id, data) {
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.abrupt("return", request({
            url: "cmdb/v1/dynamicgroup/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _updateDynamicGroup.apply(this, arguments);
}
export function queryDynamicGroup(_x26, _x27) {
  return _queryDynamicGroup.apply(this, arguments);
}
function _queryDynamicGroup() {
  _queryDynamicGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee18(id, params) {
    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          return _context18.abrupt("return", request({
            url: "cmdb/v1/dynamicgroup/query/".concat(id),
            params: params
          }));
        case 1:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _queryDynamicGroup.apply(this, arguments);
}
export function getCmdbModelGroups(_x28) {
  return _getCmdbModelGroups.apply(this, arguments);
}
function _getCmdbModelGroups() {
  _getCmdbModelGroups = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee19(params) {
    return regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          return _context19.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_group',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _getCmdbModelGroups.apply(this, arguments);
}
export function getCmdbModelGroup(_x29) {
  return _getCmdbModelGroup.apply(this, arguments);
}
function _getCmdbModelGroup() {
  _getCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee20(id) {
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          return _context20.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _getCmdbModelGroup.apply(this, arguments);
}
export function deleteCmdbModelGroup(_x30) {
  return _deleteCmdbModelGroup.apply(this, arguments);
}
function _deleteCmdbModelGroup() {
  _deleteCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee21(id) {
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _deleteCmdbModelGroup.apply(this, arguments);
}
export function createCmdbModelGroup(_x31) {
  return _createCmdbModelGroup.apply(this, arguments);
}
function _createCmdbModelGroup() {
  _createCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee22(data) {
    return regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          return _context22.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_group',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _createCmdbModelGroup.apply(this, arguments);
}
export function updateCmdbModelGroup(_x32, _x33) {
  return _updateCmdbModelGroup.apply(this, arguments);
}
function _updateCmdbModelGroup() {
  _updateCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee23(id, data) {
    return regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          return _context23.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _updateCmdbModelGroup.apply(this, arguments);
}
export function getCmdbModels(_x34) {
  return _getCmdbModels.apply(this, arguments);
}
function _getCmdbModels() {
  _getCmdbModels = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee24(params) {
    return regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _getCmdbModels.apply(this, arguments);
}
export function getCmdbModel(_x35) {
  return _getCmdbModel.apply(this, arguments);
}
function _getCmdbModel() {
  _getCmdbModel = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee25(id) {
    return regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.abrupt("return", request({
            url: "cmdb/v1/cmdb_model/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _getCmdbModel.apply(this, arguments);
}
export function deleteCmdbModel(_x36) {
  return _deleteCmdbModel.apply(this, arguments);
}
function _deleteCmdbModel() {
  _deleteCmdbModel = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee26(id) {
    return regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          return _context26.abrupt("return", request({
            url: "cmdb/v1/cmdb_model/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _deleteCmdbModel.apply(this, arguments);
}
export function createCmdbModel(_x37) {
  return _createCmdbModel.apply(this, arguments);
}
function _createCmdbModel() {
  _createCmdbModel = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee27(data) {
    return regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          return _context27.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _createCmdbModel.apply(this, arguments);
}
export function updateCmdbModel(_x38, _x39) {
  return _updateCmdbModel.apply(this, arguments);
}
function _updateCmdbModel() {
  _updateCmdbModel = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee28(id, data) {
    return regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          return _context28.abrupt("return", request({
            url: "cmdb/v1/cmdb_model/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _updateCmdbModel.apply(this, arguments);
}
export function getCmdbModules(_x40) {
  return _getCmdbModules.apply(this, arguments);
}
function _getCmdbModules() {
  _getCmdbModules = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee29(params) {
    return regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          return _context29.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_module',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _getCmdbModules.apply(this, arguments);
}
export function getCmdbModule(_x41) {
  return _getCmdbModule.apply(this, arguments);
}
function _getCmdbModule() {
  _getCmdbModule = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee30(id) {
    return regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          return _context30.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _getCmdbModule.apply(this, arguments);
}
export function deleteCmdbModule(_x42) {
  return _deleteCmdbModule.apply(this, arguments);
}
function _deleteCmdbModule() {
  _deleteCmdbModule = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee31(id) {
    return regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          return _context31.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _deleteCmdbModule.apply(this, arguments);
}
export function createCmdbModule(_x43) {
  return _createCmdbModule.apply(this, arguments);
}
function _createCmdbModule() {
  _createCmdbModule = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee32(data) {
    return regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          return _context32.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_module',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _createCmdbModule.apply(this, arguments);
}
export function updateCmdbModule(_x44, _x45) {
  return _updateCmdbModule.apply(this, arguments);
}
function _updateCmdbModule() {
  _updateCmdbModule = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee33(id, data) {
    return regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          return _context33.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _updateCmdbModule.apply(this, arguments);
}
export function getCmdbFields(_x46) {
  return _getCmdbFields.apply(this, arguments);
}
function _getCmdbFields() {
  _getCmdbFields = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee34(params) {
    return regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          return _context34.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_field',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _getCmdbFields.apply(this, arguments);
}
export function getCmdbField(_x47) {
  return _getCmdbField.apply(this, arguments);
}
function _getCmdbField() {
  _getCmdbField = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee35(id) {
    return regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          return _context35.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _getCmdbField.apply(this, arguments);
}
export function deleteCmdbField(_x48) {
  return _deleteCmdbField.apply(this, arguments);
}
function _deleteCmdbField() {
  _deleteCmdbField = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee36(id) {
    return regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          return _context36.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return _deleteCmdbField.apply(this, arguments);
}
export function createCmdbField(_x49) {
  return _createCmdbField.apply(this, arguments);
}
function _createCmdbField() {
  _createCmdbField = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee37(data) {
    return regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          return _context37.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_field',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return _createCmdbField.apply(this, arguments);
}
export function updateCmdbField(_x50, _x51) {
  return _updateCmdbField.apply(this, arguments);
}
function _updateCmdbField() {
  _updateCmdbField = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee38(id, data) {
    return regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          return _context38.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return _updateCmdbField.apply(this, arguments);
}
export function getInstances(_x52, _x53) {
  return _getInstances.apply(this, arguments);
}
function _getInstances() {
  _getInstances = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee39(params, data) {
    return regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          return _context39.abrupt("return", request({
            url: "cmdb/v1/instance/search",
            method: 'post',
            params: _objectSpread({}, params),
            data: data
          }));
        case 1:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return _getInstances.apply(this, arguments);
}
export function getInstanceBizCloudCount(_x54) {
  return _getInstanceBizCloudCount.apply(this, arguments);
}
function _getInstanceBizCloudCount() {
  _getInstanceBizCloudCount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee40(biz_id) {
    return regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          return _context40.abrupt("return", request({
            url: "cmdb/v1/instance/".concat(biz_id, "/count"),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return _getInstanceBizCloudCount.apply(this, arguments);
}
export function deleteInstance(_x55) {
  return _deleteInstance.apply(this, arguments);
}
function _deleteInstance() {
  _deleteInstance = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee41(data) {
    return regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          return _context41.abrupt("return", request({
            url: "cmdb/v1/instance",
            method: 'delete',
            data: data
          }));
        case 1:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return _deleteInstance.apply(this, arguments);
}
export function createInstance(_x56) {
  return _createInstance.apply(this, arguments);
}
function _createInstance() {
  _createInstance = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee42(data) {
    return regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          return _context42.abrupt("return", request({
            url: 'cmdb/v1/instance',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return _createInstance.apply(this, arguments);
}
export function updateInstance(_x57) {
  return _updateInstance.apply(this, arguments);
}
function _updateInstance() {
  _updateInstance = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee43(data) {
    return regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          return _context43.abrupt("return", request({
            url: "cmdb/v1/instance",
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return _updateInstance.apply(this, arguments);
}
export function getCmdbTopologyTree(_x58) {
  return _getCmdbTopologyTree.apply(this, arguments);
}
function _getCmdbTopologyTree() {
  _getCmdbTopologyTree = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee44(params) {
    return regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          return _context44.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology",
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return _getCmdbTopologyTree.apply(this, arguments);
}
export function getCmdbTopology(_x59) {
  return _getCmdbTopology.apply(this, arguments);
}
function _getCmdbTopology() {
  _getCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee45(id) {
    return regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          return _context45.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return _getCmdbTopology.apply(this, arguments);
}
export function deleteCmdbTopology(_x60) {
  return _deleteCmdbTopology.apply(this, arguments);
}
function _deleteCmdbTopology() {
  _deleteCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee46(id) {
    return regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          return _context46.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return _deleteCmdbTopology.apply(this, arguments);
}
export function createCmdbTopology(_x61) {
  return _createCmdbTopology.apply(this, arguments);
}
function _createCmdbTopology() {
  _createCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee47(data) {
    return regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          return _context47.abrupt("return", request({
            url: 'cmdb/v1/cmdb_topology',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return _createCmdbTopology.apply(this, arguments);
}
export function updateCmdbTopology(_x62, _x63) {
  return _updateCmdbTopology.apply(this, arguments);
}
function _updateCmdbTopology() {
  _updateCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee48(id, data) {
    return regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          return _context48.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return _updateCmdbTopology.apply(this, arguments);
}
export function getCmdbCloudSyncTask(_x64, _x65) {
  return _getCmdbCloudSyncTask.apply(this, arguments);
}
function _getCmdbCloudSyncTask() {
  _getCmdbCloudSyncTask = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee49(biz_id, params) {
    return regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          return _context49.abrupt("return", request({
            url: 'cmdb/v1/cmdb_cloud_sync_task',
            params: _objectSpread({
              biz_id: biz_id
            }, params)
          }));
        case 1:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));
  return _getCmdbCloudSyncTask.apply(this, arguments);
}